import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaScrollContainer from './VaScrollContainer.vue'

export const VaScrollContainer = withConfigTransport(_VaScrollContainer)
